import React from 'react'
import { Prompt } from 'react-router'

const PromptAlertComponent = (props) => {
  return (<Prompt
    when={props.when}
    message="You have unsaved changes that will be lost if you decide to continue. Are you sure you want to leave this page?"
  />)
}

export default PromptAlertComponent
